"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getConsultantInfoSlots = exports.default = exports.ConsultantInfo = void 0;
var _icons = require("@ori-ui/icons");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _consultantInfoClasses = require("./consultantInfoClasses");
var _jsxRuntime = require("react/jsx-runtime");
var getConsultantInfoSlots = function(ownerState) {
    var size = ownerState.size;
    return {
        root: [
            'root',
            "size".concat((0, _utils.capitalize)(size))
        ],
        consultantTitle: [
            'consultantTitle'
        ],
        profilePicture: [
            'profilePicture'
        ],
        consultantName: [
            'consultantName'
        ],
        consultantNumber: [
            'consultantNumber'
        ],
        content: [
            'content'
        ],
        avatarIcon: [
            'avatarIcon'
        ]
    };
};
exports.getConsultantInfoSlots = getConsultantInfoSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getConsultantInfoSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _consultantInfoClasses.getConsultantInfoUtilityClass, classes);
    return composedClasses;
};
var ConsultantInfoRoot = (0, _material.styled)('div', {
    name: 'MuiOriConsultantInfo',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            styles["size".concat((0, _utils.capitalize)(ownerState.size))]
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: 'auto auto 1fr',
        gridTemplateRows: 'auto auto auto auto',
        gap: theme.spacing(1, 4),
        gridTemplateAreas: "\n        'profile-picture consultant-name    consultant-name'\n        'profile-picture consultant-title   consultant-title'\n        'profile-picture consultant-number  consultant-number'\n        'profile-picture content            content'\n        "
    }, ownerState.hasChild && {
        gridTemplateAreas: "\n        'profile-picture consultant-name    consultant-name'\n        'profile-picture consultant-title   consultant-title'\n        'profile-picture content            content'\n        "
    });
});
var ProfilePicture = (0, _material.styled)(_material.Avatar, {
    name: 'MuiOriConsultantInfo',
    slot: 'ProfilePicture',
    overridesResolver: function(_, styles) {
        return [
            styles.profilePicture
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        gridArea: 'profile-picture',
        alignSelf: 'start',
        width: 85,
        height: 85,
        backgroundColor: theme.palette.grey[100],
        fontSize: theme.typography.h3.fontSize,
        fontWeight: 'bold'
    }, ownerState.size === 'large' && {
        width: 140,
        height: 140
    });
});
var ConsultantName = (0, _material.styled)(_material.Typography, {
    name: 'MuiOriConsultantInfo',
    slot: 'ConsultantName',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.consultantName
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        gridArea: 'consultant-name',
        alignSelf: 'start'
    }, ownerState.size === 'large' && {
        fontSize: '3.5rem'
    });
});
var ConsultantTitle = (0, _material.styled)(_material.Typography, {
    name: 'MuiOriConsultantInfo',
    slot: 'ConsultantTitle',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.consultantTitle
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        gridArea: 'consultant-title',
        alignSelf: 'start'
    }, ownerState.size === 'large' && {
        fontSize: '2rem'
    }, ownerState.hasChild && {
        color: theme.palette.grey.A700,
        fontWeight: 'bold'
    });
});
var ConsultantNumber = (0, _material.styled)(_material.Typography, {
    name: 'MuiOriConsultantInfo',
    slot: 'ConsultantNumber',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.consultantNumber
        ];
    }
})(function(param) {
    var theme = param.theme;
    return {
        gridArea: 'consultant-number',
        color: theme.palette.grey.A700,
        alignSelf: 'start'
    };
});
var Content = (0, _material.styled)(_material.Typography, {
    name: 'MuiOriConsultantInfo',
    slot: 'Content',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.content
        ];
    }
})(function(param) {
    var theme = param.theme;
    return {
        gridArea: 'content',
        paddingTop: theme.spacing(2),
        alignSelf: 'start'
    };
});
var Icon = (0, _material.styled)(_icons.UserFilled, {
    name: 'MuiOriConsultantInfo',
    slot: 'AvatarIcon',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.avatarIcon
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        fontSize: '4rem',
        color: theme.palette.grey[500]
    }, ownerState.size === 'large' && {
        fontSize: '7.5rem'
    });
});
var ConsultantInfo = exports.ConsultantInfo = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriConsultantInfo'
    });
    var profilePictureUrl = props.profilePictureUrl, consultantName = props.consultantName, consultantTitle = props.consultantTitle, consultantNumber = props.consultantNumber, className = props.className, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, children = props.children, other = _object_without_properties(props, [
        "profilePictureUrl",
        "consultantName",
        "consultantTitle",
        "consultantNumber",
        "className",
        "size",
        "component",
        "children"
    ]);
    var ownerState = (0, _react.useMemo)(function() {
        return _object_spread_props(_object_spread({}, props), {
            size: size,
            hasChild: Boolean(children)
        });
    }, [
        props,
        size,
        children
    ]);
    var classes = useUtilityClasses(ownerState);
    var imageProps = (0, _react.useMemo)(function() {
        return _object_spread({
            ownerState: ownerState,
            className: classes.profilePicture
        }, profilePictureUrl && {
            alt: 'profile-picture',
            src: profilePictureUrl
        }, !profilePictureUrl && {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                ownerState: ownerState,
                className: classes.avatarIcon
            })
        });
    }, [
        profilePictureUrl,
        classes,
        ownerState
    ]);
    var consultantInfoTitle = (0, _react.useMemo)(function() {
        if (ownerState.hasChild) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ConsultantTitle, {
                ownerState: ownerState,
                className: classes.consultantTitle,
                children: [
                    consultantTitle,
                    " | ",
                    consultantNumber
                ]
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsultantTitle, {
                    ownerState: ownerState,
                    className: classes.consultantTitle,
                    children: consultantTitle
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsultantNumber, {
                    ownerState: ownerState,
                    className: classes.consultantNumber,
                    children: consultantNumber
                })
            ]
        });
    }, [
        classes,
        consultantTitle,
        consultantNumber,
        ownerState
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ConsultantInfoRoot, _object_spread_props(_object_spread({
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        as: component
    }, other), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfilePicture, _object_spread({}, imageProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsultantName, {
                noWrap: true,
                ownerState: ownerState,
                className: classes.consultantName,
                variant: "h6",
                gutterBottom: false,
                children: consultantName
            }),
            consultantInfoTitle,
            children === null || typeof children === 'undefined' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Content, {
                as: "span",
                ownerState: ownerState,
                className: classes.content,
                children: children
            })
        ]
    }));
});
var _default = exports.default = ConsultantInfo; //# sourceMappingURL=ConsultantInfo.js.map
